import { Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { CompanyListComponent } from './companies/company-list.component';
import { ContactListComponent } from './contacts/contact-list.component';
import { ContactDetailComponent } from './contacts/contact-detail.component';
import { ContactLinkedInComponent } from './contacts/contact-linkedin.component';
import { AudienceListComponent } from './audiences/audience-list.component';
import { AudienceDetailComponent } from './audiences/audience-detail.component';
import { TargetAreaListComponent } from './target-areas/target-area-list.component';
import { RecordListComponent } from './records/record-list.component';

export const appRoutes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'target-areas/:serviceId',
    component: TargetAreaListComponent
  },
  {
    path: 'records',
    component: RecordListComponent
  },
  {
    path: 'companies/:serviceId/:locationId',
    component: CompanyListComponent
  },
  {
    path: 'audiences/:serviceId',
    component: AudienceListComponent
  },
  {
    path: 'audiences/:serviceId/:audienceId',
    component: AudienceDetailComponent
  },
  {
    path: 'contacts/:serviceId/:locationId',
    component: ContactListComponent
  },
  {
    path: 'contacts/:serviceId/:locationId/:contactId/linkedin',
    component: ContactLinkedInComponent
  },
  {
    path: 'contacts/:serviceId/:locationId/:contactId',
    component: ContactDetailComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];

